import { Box } from '@chakra-ui/react';
import React from 'react';
import { ReactImageGalleryItem } from 'react-image-gallery';
import Image from 'next/image';

const PADDING = 80;
const LANDSCAPE_RATIO = 0.6669891304;
// eslint-disable-next-line react/display-name
const GalleryItem = React.memo(
  ({
    original,
    originalHeight,
    originalWidth,
    blurData,
    originalAlt = '',
    isFullScreen,
  }: ReactImageGalleryItem & {
    blurData: string;
    isFullScreen: boolean;
  }) => {
    const styledWidth =
      (originalHeight ?? 0) > (originalWidth ?? 0)
        ? {
            width: 'auto',
            height: `calc((100vw - ${PADDING}px) * ${LANDSCAPE_RATIO})`,
            maxHeight: '739px',
          }
        : {};

    return isFullScreen ? (
      <Box position="relative" h="calc(100vh - 80px)">
        <Image
          src={original}
          alt={originalAlt}
          fill
          blurDataURL={blurData}
          placeholder="blur"
          style={{ objectFit: 'contain' }}
        />
      </Box>
    ) : (
      <Image
        src={original}
        alt={originalAlt}
        height={originalHeight}
        width={originalWidth}
        blurDataURL={blurData}
        placeholder="blur"
        style={{
          maxWidth: '100%',
          height: 'auto',
          ...styledWidth,
        }}
      />
    );
  }
);

export default GalleryItem;
